import { render, staticRenderFns } from "./AmazingDiscount.vue?vue&type=template&id=becbdd3e&scoped=true&"
import script from "./AmazingDiscount.vue?vue&type=script&lang=js&"
export * from "./AmazingDiscount.vue?vue&type=script&lang=js&"
import style0 from "./AmazingDiscount.vue?vue&type=style&index=0&id=becbdd3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becbdd3e",
  null
  
)

export default component.exports